import type { RiskAssessmentResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useCallback } from 'react'
import { useQuery } from 'react-query'

const useRiskAssessmentData = (
  riskAssessmentId: string | undefined,
  onSuccess?: (data: GetRiskAssessmentQueryResponse) => void
) => {
  const handleOnSuccess = useCallback(
    (data: GetRiskAssessmentQueryResponse) => {
      onSuccess?.(data)
    },
    [onSuccess]
  )

  const { isLoading, data, refetch, error } =
    useQuery<GetRiskAssessmentQueryResponse>(
      ['risk-assessment', riskAssessmentId],
      () => getJSON({ url: getQueryUrl(riskAssessmentId) }),
      {
        onSuccess: handleOnSuccess,
        enabled: Boolean(riskAssessmentId),
        refetchOnMount: 'always'
      }
    )

  return {
    riskAssessment: data?.result,
    isLoading,
    refetch,
    error
  }
}

export type GetRiskAssessmentQueryResponse = {
  result?: RiskAssessmentResponse
}

const getQueryUrl = (riskAssessmentId: string | undefined) =>
  `/api/list/risk-assessments/${riskAssessmentId}`

export default useRiskAssessmentData
